<script setup>
import JetCheckbox from '@/Jetstream/Checkbox.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetDropdown from '@/Jetstream/Dropdown.vue'
import JetDropdownLink from '@/Jetstream/DropdownLink.vue'
import axios from 'axios'
import { useForm, usePage } from '@inertiajs/inertia-vue3'
import { ref } from 'vue';

window.$ = require('jquery');

const props = defineProps({
    sort_by: String,
    property_statuses: Object,
    property_types: Object,
    property_interior: Object,
    property_locations: Object,
})

const filter = useForm({
    search: '',
    status: [],
    property_type: [],
    interior: [],
    location: [],
    price: {
        from: 20000,
        to: 300000
    },
    bedroom: [],
    area: {
        from: 500,
        to: 9000
    }
});

const filtersUpdated = _.debounce(function(){
    if(filter.price && filter.price.from && filter.price.to  && (Number(filter.price.from) < Number(filter.price.to))){

        document.querySelectorAll('.price-input').forEach(element => {
            element.style.border = '1px solid #686767';
        });

        emitter.emit('filterUpdated', {
            search: filter.search,
            status: filter.status,
            type: filter.property_type,
            interior: filter.interior,
            location: filter.location,
            sort_by: props.sort_by,
            area: filter.area,
            price: filter.price,
            bedroom: filter.bedroom,
        });
    }
    else{
        document.querySelectorAll('.price-input').forEach(element => {
            element.style.border = '1px solid #ce1818';
        });
    }
}, 1500);

filter.search = (route().params.search != undefined && route().params.search != '') ? route().params.search : '';
filter.status = (route().params.status != undefined && route().params.status != '') ? route().params.status.split(',') : [];
filter.property_type = (route().params.type != undefined && route().params.type != '') ? route().params.type.split(',') : [];
filter.interior = (route().params.interior != undefined && route().params.interior != '') ? route().params.interior.split(',') : [];
filter.location = (route().params.location != undefined && route().params.location != '') ? route().params.location.split(',') : [];
filter.price = (route().params.price != undefined && route().params.price != '') ? {from: route().params.price.split(',')[0], to: route().params.price.split(',')[1]} : {from: 20000, to: 300000};
filter.bedroom = (route().params.bedroom != undefined && route().params.bedroom != '') ? route().params.bedroom.split(',') : [];
filter.area = (route().params.area != undefined && route().params.area != '') ? {from: route().params.area.split(',')[0], to: route().params.area.split(',')[1]} : {from: 500, to: 9000};

setTimeout(() => {
    $('.irs.irs--round').remove();

    $("#js-range-slider-area").ionRangeSlider({
        type: "double",
        min: 50,
        max: 9000,
        from: filter.area.from,
        to: filter.area.to,
        grid: false,
        skin: "round",
        prettify_enabled: true,
        prettify_separator: ",",
        onFinish: function(data){
            emitter.emit('filterUpdated', {
                search: filter.search,
                status: filter.status,
                type: filter.property_type,
                interior: filter.interior,
                location: filter.location,
                sort_by: props.sort_by,
                area: {from: data.from, to: data.to},
                price: filter.price,
                bedroom: filter.bedroom,
            });
        }
    });

    $("#js-range-slider-price").ionRangeSlider({
        type: "double",
        min: 10000,
        max: 900000,
        from: filter.price.from,
        to: filter.price.to,
        grid: false,
        skin: "round",
        prettify_enabled: true,
        prettify_separator: ",",
        onFinish: function(data){
            emitter.emit('filterUpdated', {
                search: filter.search,
                status: filter.status,
                type: filter.property_type,
                interior: filter.interior,
                location: filter.location,
                sort_by: props.sort_by,
                area: filter.area,
                price: {from: data.from, to: data.to},
                bedroom: filter.bedroom,
            });
        }
    });
}, 1000);

const location_filter = useForm({
    get_property_locations: props.property_locations,
    searchLocation: ''
});

const updateLocations = function() {
    axios.get('/api/property-locations', {
        params: {
            search: location_filter.searchLocation
        }
    }).then(response => {
        location_filter.get_property_locations = response.data;
    }).catch(error => {
        location_filter.get_property_locations = {};
    });
};

const propertyList = ref({});

const getPropertiesAndLocations = function () {
    axios.get('/api/get-property-and-locations', {
        params: {
            search: filter.search
        }
    }).then(response => {
        propertyList.value = response.data;
    }).catch();
}

const filterTitle = (languages) => {
    if(languages){
        languages = JSON.parse(languages);
        if(languages && languages[0] && languages[0].title){
            return languages[0].title;
        }
    }
    return null;
}

</script>

<script>
export default {
    mounted(){
        if(window.innerWidth < 992){
            document.querySelectorAll('.properties-filter .dropdown').forEach(element => {
                element.classList.add('accordion')
                element.classList.add('accordion-item')
                element.classList.remove('dropdown')
            });

            document.querySelectorAll('.properties-filter .dropdown-toggle').forEach((element, index) => {
                element.classList.add('accordion-button')
                element.classList.add('collapsed')
                element.setAttribute('data-bs-toggle', 'collapse');
                element.setAttribute('data-bs-target', '#' + 'accordion-' + index);
                element.classList.remove('dropdown-toggle')

                element.querySelector('.fa-chevron-down')?.remove();

                element.nextElementSibling.classList.add('accordion-collapse')
                element.nextElementSibling.classList.add('collapse')
                element.nextElementSibling.id = 'accordion-' + index;
                element.nextElementSibling.classList.add('container')
                element.nextElementSibling.classList.remove('dropdown-menu')
            });

            let sliders = document.getElementById('accordionExample')?.querySelector('.filters-wrapper');
            document.getElementById('accordionExample')?.remove();
            if(sliders){
                document.querySelector('.selectFilters')?.append(sliders);
            }
        }
    },
    methods: {
        toggleMobileFilter(){
            if(document.querySelector('.properties-filter').classList.contains('opened')){
                document.querySelector('.properties-filter').classList.remove('opened')
            }
            else{
                document.querySelector('.properties-filter').classList.add('opened')
            };
        }
    }
}
</script>

<template>
    <div class="properties-filter">
        <div class="m-2 m-lg-auto row">
            <div class="col-12 d-lg-none text-end">
                <button class="btn px-0" type="button" @click="toggleMobileFilter()">
                    <svg xmlns="http://www.w3.org/2000/svg" height="1.5em" width="1.5em" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16" style="color: var(--secondary-color)">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                </button>
            </div>
            <div class="col-12 col-xl-4">
                <form class="filter-input-form">
                    <div class="search-input position-relative">
                        <div class="search-icon">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path></svg>
                        </div>
                        <JetInput placeholder="Search Properties By Name, Location" id="search" v-model="filter.search" name="search" @keyup="getPropertiesAndLocations()" />
                        <div class="clearSearch d-flex align-itens-center" @click="filter.search = ''" v-if="filter.search">
                            <svg xmlns="http://www.w3.org/2000/svg" style="width: 20px" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div class="search-result" v-if="propertyList.length > 0">
                            <div v-for="list in propertyList" :key="list.id">
                                <a v-if="list.tower || list.sub_community || list.city" class="p-1 d-flex align-items-center text-decoration-none text-dark text-truncate" @click="$inertia.visit(route().current(), {data: {search: (((list.tower != null ? list.tower + ', ' : '') + (list.sub_community != null ? list.sub_community + ', ' : '') + (list.community != null ? list.community + ', ' : '') + (list.city != null ? list.city : '')) + '.')}})"
                                    :title="(((list.tower != null ? list.tower + ', ' : '') + (list.sub_community != null ? list.sub_community + ', ' : '') + (list.community != null ? list.community + ', ' : '') + (list.city != null ? list.city : '')) + '.')">
                                    <span class="pe-1 pb-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" style="width: 18px" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                    </span>{{ ((list.tower != null ? list.tower + ', ' : '') + (list.sub_community != null ? list.sub_community + ', ' : '') + (list.community != null ? list.community + ', ' : '') + (list.city != null ? list.city : '')) + '.' }}
                                </a>
                                <a v-else class="p-1 d-flex align-items-center text-decoration-none text-dark text-truncate"
                                    @click="$inertia.visit(route().current(), {data: {search: filterTitle(list.languages)}})"
                                    :title="filterTitle(list.languages)">
                                    <span class="pe-1 pb-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" style="width: 18px" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>
                                    </span>{{ filterTitle(list.languages) }}
                                </a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-12 mt-2 mt-xl-auto col-xl-8 selectFilters">
                <div class="filters-wrapper d-flex justify-content-between flex-column flex-lg-row flex-lg-wrap" id="filter-wrapper">
                    <!-- <div class="dropdown">
                        <button class="dropdown-toggle w-100 d-flex justify-content-between" type="button" aria-expanded="false" :class="filter.status.length > 0 ? 'filter-active' : ''">
                            <span class="">Property Status</span>
                            <span class="">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                </svg>
                            </span>
                        </button>
                        <ul class="dropdown-menu row extra-width" aria-labelledby="dropdownMenuButton1">
                            <div class="col-12 col-lg-6" v-for="item in property_statuses" :key="item.id">
                                <JetLabel :for="item.slug">
                                    <div class="filter-option">
                                        <JetCheckbox :id="item.slug" v-model:checked="filter.status" name="status" :value="item.id.toString()" @change="filtersUpdated()" />
                                        {{ item.name }}
                                    </div>
                                </JetLabel>
                            </div>
                        </ul>
                    </div> -->
                    <div class="dropdown mt-1 mt-lg-auto">
                        <button class="dropdown-toggle w-100 d-flex justify-content-between" type="button" aria-expanded="false" :class="filter.property_type.length > 0 ? 'filter-active' : ''">
                            <span class="">Property Type</span>
                            <span class="">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                </svg>
                            </span>
                        </button>
                        <ul class="dropdown-menu row extra-width" aria-labelledby="dropdownMenuButton1">
                            <div class="col-12 col-lg-6 pt-1" v-for="item in property_types" :key="item.id">
                                <JetLabel :for="item.name" :title="item.name">
                                    <div class="filter-option text-truncate">
                                        <JetCheckbox :id="item.name" v-model:checked="filter.property_type" name="type" :value="item.id.toString()" @change="filtersUpdated()" />
                                        <span class="ps-2">{{ item.name }}</span>
                                    </div>
                                </JetLabel>
                            </div>
                        </ul>
                    </div>
                    <div class="dropdown mt-1 mt-lg-auto">
                        <button class="dropdown-toggle w-100 d-flex justify-content-between" type="button" aria-expanded="false" :class="filter.bedroom.length > 0 ? 'filter-active' : ''">
                            <span class="">Bedrooms</span>
                            <span class="">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                </svg>
                            </span>
                        </button>
                        <ul class="dropdown-menu row extra-width" aria-labelledby="dropdownMenuButton1">
                            <div class="col-12 col-lg-6 py-1">
                                <JetLabel for="bedroom-1" title="1">
                                    <div class="filter-option text-truncate d-flex align-items-center">
                                        <JetCheckbox id="bedroom-1" v-model:checked="filter.bedroom" name="bedroom" value="1" @change="filtersUpdated()" />
                                        <span class="ps-2">1</span>
                                    </div>
                                </JetLabel>
                            </div>
                            <div class="col-12 col-lg-6 py-1">
                                <JetLabel for="bedroom-2" title="2">
                                    <div class="filter-option text-truncate d-flex align-items-center">
                                        <JetCheckbox id="bedroom-2" v-model:checked="filter.bedroom" name="bedroom" value="2" @change="filtersUpdated()" />
                                        <span class="ps-2">2</span>
                                    </div>
                                </JetLabel>
                            </div>
                            <div class="col-12 col-lg-6 py-1">
                                <JetLabel for="bedroom-3" title="3">
                                    <div class="filter-option text-truncate d-flex align-items-center">
                                        <JetCheckbox id="bedroom-3" v-model:checked="filter.bedroom" name="bedroom" value="3" @change="filtersUpdated()" />
                                        <span class="ps-2">3</span>
                                    </div>
                                </JetLabel>
                            </div>
                            <div class="col-12 col-lg-6 py-1">
                                <JetLabel for="bedroom-4" title="4">
                                    <div class="filter-option text-truncate d-flex align-items-center">
                                        <JetCheckbox id="bedroom-4" v-model:checked="filter.bedroom" name="bedroom" value="4" @change="filtersUpdated()" />
                                        <span class="ps-2">4</span>
                                    </div>
                                </JetLabel>
                            </div>
                            <div class="col-12 col-lg-6 py-1">
                                <JetLabel for="bedroom-5" title="5">
                                    <div class="filter-option text-truncate d-flex align-items-center">
                                        <JetCheckbox id="bedroom-5" v-model:checked="filter.bedroom" name="bedroom" value="5" @change="filtersUpdated()" />
                                        <span class="ps-2">5</span>
                                    </div>
                                </JetLabel>
                            </div>
                            <div class="col-12 col-lg-6 py-1">
                                <JetLabel for="bedroom-6" title="6">
                                    <div class="filter-option text-truncate d-flex align-items-center">
                                        <JetCheckbox id="bedroom-6" v-model:checked="filter.bedroom" name="bedroom" value="6" @change="filtersUpdated()" />
                                        <span class="ps-2">6</span>
                                    </div>
                                </JetLabel>
                            </div>
                            <div class="col-12 col-lg-6 py-1">
                                <JetLabel for="bedroom-7" title="7">
                                    <div class="filter-option text-truncate d-flex align-items-center">
                                        <JetCheckbox id="bedroom-7" v-model:checked="filter.bedroom" name="bedroom" value="7" @change="filtersUpdated()" />
                                        <span class="ps-2">7</span>
                                    </div>
                                </JetLabel>
                            </div>
                            <div class="col-12 col-lg-6 py-1">
                                <JetLabel for="bedroom-7+" title="7+">
                                    <div class="filter-option text-truncate d-flex align-items-center">
                                        <JetCheckbox id="bedroom-7+" v-model:checked="filter.bedroom" name="bedroom" value="7+" @change="filtersUpdated()" />
                                        <span class="ps-2">7+</span>
                                    </div>
                                </JetLabel>
                            </div>
                        </ul>
                    </div>
                    <div class="dropdown mt-1 mt-lg-auto">
                        <button class="dropdown-toggle w-100 d-flex justify-content-between" type="button" aria-expanded="false"
                            :class="(filter.price && filter.price.from && filter.price.to && (filter.price.from != 20000 || filter.price.to != 300000) ) ? 'filter-active' : ''">
                            <span class="">Price</span>
                            <span class="">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                </svg>
                            </span>
                        </button>
                        <ul class="dropdown-menu extra-width flex-column" aria-labelledby="dropdownMenuButton1">
                            <div class="d-flex justify-content-between align-items-center w-100 py-2">
                                <select class="price-input bg-white border-0 py-2" name="min_price" id="min_price" @change="filtersUpdated()" v-model="filter.price.from">
                                    <option value="" selected disabled>Min. Price</option>
                                    <option value="20000">20,000</option>
                                    <option value="30000">30,000</option>
                                    <option value="40000">40,000</option>
                                    <option value="50000">50,000</option>
                                    <option value="60000">60,000</option>
                                    <option value="70000">70,000</option>
                                    <option value="80000">80,000</option>
                                    <option value="90000">90,000</option>
                                    <option value="110000">1,10,000</option>
                                    <option value="120000">1,20,000</option>
                                    <option value="130000">1,30,000</option>
                                    <option value="140000">1,40,000</option>
                                    <option value="150000">1,50,000</option>
                                    <option value="160000">1,60,000</option>
                                    <option value="170000">1,70,000</option>
                                    <option value="180000">1,80,000</option>
                                    <option value="190000">1,90,000</option>
                                    <option value="200000">2,00,000</option>
                                    <option value="225000">2,25,000</option>
                                    <option value="250000">2,50,000</option>
                                    <option value="275000">2,75,000</option>
                                    <option value="300000">3,00,000</option>
                                </select>
                                <p class="mb-0 px-2">To</p>
                                <select class="price-input bg-white border-0 py-2" name="max_price" id="max_price" @change="filtersUpdated()" v-model="filter.price.to">
                                    <option value="" selected disabled>Max. Price</option>
                                    <option value="20000">20,000</option>
                                    <option value="30000">30,000</option>
                                    <option value="40000">40,000</option>
                                    <option value="50000">50,000</option>
                                    <option value="60000">60,000</option>
                                    <option value="70000">70,000</option>
                                    <option value="80000">80,000</option>
                                    <option value="90000">90,000</option>
                                    <option value="110000">1,10,000</option>
                                    <option value="120000">1,20,000</option>
                                    <option value="130000">1,30,000</option>
                                    <option value="140000">1,40,000</option>
                                    <option value="150000">1,50,000</option>
                                    <option value="160000">1,60,000</option>
                                    <option value="170000">1,70,000</option>
                                    <option value="180000">1,80,000</option>
                                    <option value="190000">1,90,000</option>
                                    <option value="200000">2,00,000</option>
                                    <option value="225000">2,25,000</option>
                                    <option value="250000">2,50,000</option>
                                    <option value="275000">2,75,000</option>
                                    <option value="300000">3,00,000</option>
                                </select>
                            </div>
                            <p class="mb-0 text-end"><small class="text-muted">(AED)</small></p>
                        </ul>
                    </div>
                    <div class="dropdown mt-1 mt-lg-auto">
                        <button class="dropdown-toggle w-100 d-flex justify-content-between" type="button" aria-expanded="false"
                            :class="(filter.area && filter.area.from && filter.area.to && (filter.area.from != 500 || filter.area.to != 9000) ) ? 'filter-active' : ''">
                            <span class="">Area</span>
                            <span class="">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                </svg>
                            </span>
                        </button>
                        <ul class="dropdown-menu extra-width flex-column" aria-labelledby="dropdownMenuButton1">
                            <div class="d-flex justify-content-between align-items-center w-100 py-2">
                                <select class="price-input bg-white border-0 py-2" name="min_area" id="min_area" @change="filtersUpdated()" v-model="filter.area.from">
                                    <option value="" selected disabled>Min. Area</option>
                                    <option value="500">500</option>
                                    <option value="600">600</option>
                                    <option value="700">700</option>
                                    <option value="800">800</option>
                                    <option value="900">900</option>
                                    <option value="1000">1000</option>
                                    <option value="1100">1100</option>
                                    <option value="1200">1200</option>
                                    <option value="1300">1300</option>
                                    <option value="1400">1400</option>
                                    <option value="1500">1500</option>
                                    <option value="1600">1600</option>
                                    <option value="1800">1800</option>
                                    <option value="2000">2000</option>
                                    <option value="2200">2200</option>
                                    <option value="2400">2400</option>
                                    <option value="2600">2600</option>
                                    <option value="2800">2800</option>
                                    <option value="3000">3000</option>
                                    <option value="3200">3200</option>
                                    <option value="3400">3400</option>
                                    <option value="3600">3600</option>
                                    <option value="3800">3800</option>
                                    <option value="4000">4000</option>
                                    <option value="4600">4600</option>
                                    <option value="5000">5000</option>
                                    <option value="5400">5400</option>
                                    <option value="5600">5600</option>
                                    <option value="6200">6200</option>
                                    <option value="6600">6600</option>
                                    <option value="7000">7000</option>
                                    <option value="7400">7400</option>
                                    <option value="7800">7800</option>
                                    <option value="8200">8200</option>
                                    <option value="9000">9000</option>
                                </select>
                                <p class="mb-0 px-2">To</p>
                                <select class="price-input bg-white border-0 py-2" name="max_area" id="max_area" @change="filtersUpdated()" v-model="filter.area.to">
                                    <option value="" selected disabled>Max. Area</option>
                                    <option value="500">500</option>
                                    <option value="600">600</option>
                                    <option value="700">700</option>
                                    <option value="800">800</option>
                                    <option value="900">900</option>
                                    <option value="1000">1000</option>
                                    <option value="1100">1100</option>
                                    <option value="1200">1200</option>
                                    <option value="1300">1300</option>
                                    <option value="1400">1400</option>
                                    <option value="1500">1500</option>
                                    <option value="1600">1600</option>
                                    <option value="1800">1800</option>
                                    <option value="2000">2000</option>
                                    <option value="2200">2200</option>
                                    <option value="2400">2400</option>
                                    <option value="2600">2600</option>
                                    <option value="2800">2800</option>
                                    <option value="3000">3000</option>
                                    <option value="3200">3200</option>
                                    <option value="3400">3400</option>
                                    <option value="3600">3600</option>
                                    <option value="3800">3800</option>
                                    <option value="4000">4000</option>
                                    <option value="4600">4600</option>
                                    <option value="5000">5000</option>
                                    <option value="5400">5400</option>
                                    <option value="5600">5600</option>
                                    <option value="6200">6200</option>
                                    <option value="6600">6600</option>
                                    <option value="7000">7000</option>
                                    <option value="7400">7400</option>
                                    <option value="7800">7800</option>
                                    <option value="8200">8200</option>
                                    <option value="9000">9000</option>
                                </select>
                            </div>
                            <p class="mb-0 text-end"><small class="text-muted">(Sq. Feet)</small></p>
                        </ul>
                    </div>
                    <!-- <div class="dropdown mt-1 mt-lg-auto">
                        <button class="dropdown-toggle w-100 d-flex justify-content-between" type="button" aria-expanded="false" :class="(filter.area && (filter.area.from != 200 || filter.area.to != 8000)) ? 'filter-active' : ''">
                            <span class="">Size <span><sup>(Sq. Feet)</sup></span></span>
                            <span class="">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                </svg>
                            </span>
                        </button>
                        <ul class="dropdown-menu row extra-width" aria-labelledby="dropdownMenuButton1">
                            <div class="col-12 px-1 py-2">
                                <input type="text" class="d-none" id="js-range-slider-area">
                            </div>
                        </ul>
                    </div> -->
                    <!-- <div class="dropdown mt-1 mt-lg-auto">
                        <button class="dropdown-toggle w-100 d-flex justify-content-between" type="button" aria-expanded="false" :class="filter.location.length > 0 ? 'filter-active' : ''">
                            <span class="">Property Location &nbsp;</span>
                            <span class="">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                </svg>
                            </span>
                        </button>
                        <ul class="dropdown-menu row x-extra-width" aria-labelledby="dropdownMenuButton1">
                            <div class="col-12 mb-4">
                                <form class="filter-input-form">
                                    <div class="search-input">
                                        <div class="search-icon">
                                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path></svg>
                                        </div>
                                        <JetInput placeholder="Search Locations" id="search-location" v-model="location_filter.searchLocation" name="search_location" @keyup="updateLocations()" />
                                    </div>
                                </form>
                            </div>
                            <div class="col-12 col-lg-6" v-for="item in location_filter.get_property_locations" :key="item.id">
                                <JetLabel>
                                    <div class="filter-option d-flex align-items-center justify-content-start">
                                        <span>
                                            <JetCheckbox v-model:checked="filter.location" name="location" :value="item.id.toString()" @change="filtersUpdated()" style="width: 15px; height: 15px; padding: 5px" />
                                        </span>
                                        <span class="ms-2">
                                            {{ item.tower ? item.tower + ', ' : '' }}
                                            {{ item.sub_community ? item.sub_community + ', ' : '' }}
                                            {{ item.community ? item.community + ', ' : '' }}
                                            {{ item.city ? item.city + ', ' : '' }}
                                        </span>
                                    </div>
                                </JetLabel>
                            </div>
                        </ul>
                    </div> -->
                    <div class="dropdown mt-1 mt-lg-auto">
                        <button class="dropdown-toggle w-100 d-flex justify-content-between" type="button" aria-expanded="false" :class="filter.interior.length > 0 ? 'filter-active' : ''">
                            <span class="">Property Interior &nbsp;</span>
                            <span class="">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                </svg>
                            </span>
                        </button>
                        <ul class="dropdown-menu flex-column" aria-labelledby="dropdownMenuButton1">
                            <div v-for="item in property_interior" :key="item.id" class="pt-1">
                                <JetLabel :for="item.slug" :title="item.name">
                                    <div class="filter-option text-truncate">
                                        <JetCheckbox :id="item.slug" v-model:checked="filter.interior" name="interior" :value="item.id.toString()" @change="filtersUpdated()" />
                                        <span class="ps-2">{{ item.name }}</span>
                                    </div>
                                </JetLabel>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <div class="col-12 mt-2">
                <div class="accordion" id="accordionExample">
                    <div class="accordion-item bg-transparent border-0">
                        <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button shadow-none" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            Advance Filters
                        </button>
                        </h2>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div class="filters-wrapper d-flex justify-content-end flex-column flex-lg-row flex-lg-wrap">
                                <div class="col-lg-4 mt-1 mt-lg-auto">
                                    <div class="filter-card me-lg-2">
                                        <span class="mb-2">Price (AED)</span>
                                        <span class="">
                                            <input type="text" class="d-none" id="js-range-slider-price">
                                        </span>
                                    </div>
                                </div>
                                <div class="col-lg-4 mt-1 mt-lg-auto">
                                    <div class="filter-card me-lg-2">
                                        <span class="mb-2">Bedrooms</span>
                                        <span class="">
                                            <input type="text" class="d-none" id="js-range-slider-bedrooms">
                                        </span>
                                    </div>
                                </div>
                                <div class="col-lg-4 mt-1 mt-lg-auto">
                                    <div class="filter-card">
                                        <span class="mb-2">Size</span>
                                        <span class="">
                                            <input type="text" class="d-none" id="js-range-slider-area">
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<style scoped>
select{
    border: 1px solid #686767;
    border-radius: 0px;
    padding: 4px 12px;
    font-size: 1rem;
    color: #686767;
}
select:focus, select:focus-visible, select:active{
    border: 1px solid #686767;
    border-radius: 0px;
    box-shadow: none !important;
}
select::placeholder{
    color: #ccc;
}
</style>
